import { Routes, Route, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import TheResidenceViewer from './TheResidenceViewer'
import CasaBallroomViewer from './CasaBallroomViewer'

function Landing() {
  const navigate = useNavigate()

  const startTour = (id) => {
    navigate('/tour', { state: { id } })
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-title">
              <img src='assets/Logo_Pacmas_Text.png' className='logo-pacmas'></img>
              <img src='assets/HotelMerlynn_Map/logo MPH Original.png' className='logo-mph'></img>
            </div>
            <p className="hero-description">
              Hotel Merlyn menghadirkan inovasi virtual tour 360° yang memungkinkan calon tamu merasakan 
              pengalaman menginap secara interaktif sebelum kedatangan. Showcase ini menampilkan dua fasilitas premium unggulan hotel: 
              Kamar Tipe Residence dengan desain interior elegan, amenitas lengkap, dan tata ruang optimal 
              untuk kenyamanan maksimal, serta Casa Ballroom yang megah dan serbaguna dengan kapasitas luas, 
              fleksibilitas tata ruang, dan fasilitas modern untuk berbagai acara mulai dari pernikahan hingga konferensi bisnis. 
            </p>
          </div>
          <div className="hero-visual">
            <div className='cta-button' onClick={() => { navigate('/casa-ballroom') }}>
              <span>Casa Ballroom</span>
            </div>
            <div className='cta-button' onClick={() => { navigate('/the-residence') }}>
              <span>The Residence</span>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/the-residence" element={<TheResidenceViewer />} />
      <Route path="/casa-ballroom" element={<CasaBallroomViewer />} />
    </Routes>
  )
}
